import React from 'react';

type Props = {
  label: string;
  rowIdx: number;
  highlighted: boolean;
  editMode?: boolean;
  isSmallScreen?: boolean;
  onMouseEnter: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseLeave: () => void;
};

const TimeColumn: React.FC<Props> = ({ label, rowIdx, highlighted, editMode = false, isSmallScreen = false, onMouseEnter, onMouseLeave }) => {
  const highlightClass = highlighted ? (editMode ? 'time-header-highlight' : 'time-header-highlight-schedule') : '';
  const highlightBg = highlighted ? 'rgba(109, 40, 217, 0.08)' : 'transparent';
  return (
    <div
      className={highlightClass}
      style={{
        padding: isSmallScreen ? '0.5rem 0.125rem' : '0.5rem 0.5rem',
        borderRight: '2px solid #ffffff',
        fontSize: isSmallScreen ? '0.6rem' : '0.9rem',
        color: '#6b7280',
        fontWeight: 700,
        background: highlightBg,
        textAlign: 'right',
        borderBottom: '1px solid #dedede',
        alignContent: 'center',
      }}
      data-first-time-row={rowIdx === 0 ? 'true' : undefined}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {label}
    </div>
  );
};

export default TimeColumn;


